// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3KR3l","validationTips":"StatementDescriptor_validationTips__U2FlD"};